import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { z } from "zod";
import { forgotPasswordSchema } from "../ValidationSchema/AuthValidations/forgotPassword";
import {  loginUser, LogOut, registerUser, updateUserInfo, updateUserPassword, getCityId, getStates } from "../services/authApis";

// !------------------ create login------------------
export const login = createAsyncThunk(
    'login',
    async (credentials,{rejectWithValue })=>{
        try {
            let params=`email=${credentials.email}&password=${credentials.password}`;
            const resp=await loginUser(params);
            // console.log('resp',resp);
            return resp;
        } catch (error) {
            if(error instanceof z.ZodError){
                return rejectWithValue(error.errors);
            }
            return rejectWithValue(error.message)
        }
    }
)
// !------------------ create register------------------
export const register=createAsyncThunk(
    'register',
    async (data,{rejectWithValue})=>{
        try {
            const stateResponse = await getStates();
            const stateData = stateResponse.data
            
            const stateAcronym = Object.keys(stateData).find(
                (key) => stateData[key] === data.region_state
            );

            // console.log("sate",stateAcronym)

            const cityResponse = await getCityId(stateAcronym.toLowerCase());
            const cityData = await cityResponse.data;
            // console.log("city data",cityData)

            const cityId = Object.keys(cityData).find(
                (key) => cityData[key] === data.city
              );

            // console.log("city id", cityId)

            data.region_state = stateAcronym;
            data.city = cityId;

            const formData=new FormData();
            formData.append('business_license_copy',data.business_license_copy);
            formData.append('federal_tax_id_copy',data.federal_tax_id_copy);
            formData.append('id_driver_license',data.id_driver_license);
            let params=`first_name=${data.first_name}&last_name=${data.last_name}&email=${data.email}&telephone=${data.telephone}&fax=${data.fax}&business_name=${data.business_name}&address_1=${data.address_1}&city=${data.city}&post_code=${data.post_code}&country=${data.country}&region_state=${data.region_state}&password=${data.password}&password_confirmation=${data.password_confirmation}&subscribe_newsletter=${data.subscribe_newsletter}&remember=${data.remember}`;
            const response=await registerUser(params,formData);
            return response;
        } catch (error) {
            if(error instanceof z.ZodError){
                return rejectWithValue(error.errors);
            }
            return rejectWithValue(error.message)
        }
    }
)
// !------------------ create UpdateUser------------------
// export const updateUser = createAsyncThunk(
//     'updateUser',
//     async (data, { rejectWithValue }) => {
//       try {
//         const formData = new FormData();
        
//         let params = new URLSearchParams({
//           first_name: data.first_name,
//           last_name: data.last_name,
//           email: data.email,
//           telephone: data.telephone,
//           fax: data.fax || '',
//           business_name: data.business_name,
//           address_1: data.address_1,
//           city: data.city,
//           post_code: data.post_code,
//           country: data.country,
//           region_state: data.region_state,
//           subscribe_newsletter: data.subscribe_newsletter
//         }).toString();
  
//         if (data.business_license_copy instanceof File) {
//           formData.append('business_license_copy', data.business_license_copy);
//         } else if (data.business_license_copy) {
//           // Add the existing file path to the query params
//           params += `&business_license_copy=${encodeURIComponent(data.business_license_copy)}`;
//         }
        
//         if (data.federal_tax_id_copy instanceof File) {
//           formData.append('federal_tax_id_copy', data.federal_tax_id_copy);
//         } else if (data.federal_tax_id_copy) {
//           // Add the existing file path to the query params
//           params += `&federal_tax_id_copy=${encodeURIComponent(data.federal_tax_id_copy)}`;
//         }
        
//         formData.append('_method', 'PUT');
  
//         console.log('FormData before call:', formData);
//         console.log('Params:', params);
  
//         const response = await updateUserInfo(params, formData);
//         return response;
//       } catch (error) {
//         if (error instanceof z.ZodError) {
//           return rejectWithValue(error.errors);
//         }
//         return rejectWithValue(error.message);
//       }
//     }
//   );
export const updateUser = createAsyncThunk(
    'updateUser',
    async (data, { rejectWithValue }) => {
      try {
        const formData = new FormData();
        formData.append('_method', 'PUT');
  
        if (data.business_license_copy instanceof File) {
          formData.append('business_license_copy', data.business_license_copy);
        }
        
        if (data.federal_tax_id_copy instanceof File) {
          formData.append('federal_tax_id_copy', data.federal_tax_id_copy);
        }
  
        const params = new URLSearchParams({
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          telephone: data.telephone,
          fax: data.fax || '',
          business_name: data.business_name,
          address_1: data.address_1,
          address_2: data.address_2,
          city: data.city,
          post_code: data.post_code,
          country: data.country,
          region_state: data.region_state,
          subscribe_newsletter: data.subscribe_newsletter
        }).toString();
  
        // For debugging
        // console.log('Query params:', params);
        // console.log('FormData:', formData);
  
        const response = await updateUserInfo(params, formData);
        return response;
      } catch (error) {
        if (error instanceof z.ZodError) {
          return rejectWithValue(error.errors);
        }
        return rejectWithValue(error.message);
      }
    }
  );
//   !------------------ create updatePassword------------------
export const updatePassword = createAsyncThunk(
    'updatePassword',
    async (data, { rejectWithValue }) => {
      try {
        // Make the API call
        const formData = new FormData();
        formData.append('_method', 'PATCH');
        formData.append('password', data.password);
        formData.append('password_confirmation', data.password_confirmation);
        const response = await updateUserPassword(formData);
        return response;
      } catch (error) {
        if (error instanceof z.ZodError) {
          return rejectWithValue(error.errors);
        }
        return rejectWithValue(error.message);
      }
    }
  );
  
  
// !------------------ create forgot------------------
export const forgot=createAsyncThunk(
    'forgot',
    async (data,{rejectWithValue})=>{
        try {
            // console.log('data',data);
            forgotPasswordSchema.parse(data);
            // api call here
            return {user:{id:1,email:data.email}}
        } catch (error) {
            if(error instanceof z.ZodError){
                return rejectWithValue(error.errors);
            }
            return rejectWithValue(error.message)
        }
    }
)
// !------------------ create logout------------------
export const logout=createAsyncThunk(
    'logout',
    async ()=>{
        const response=await LogOut();
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('ageVerified');
        return response;
    }
)
// !------------------ create authSlice------------------
const initialState={
    user:JSON.parse(localStorage.getItem('user')) || null,
    loading:false,
    error:null,
    isAuthenticated:false,
    token:localStorage.getItem('token') || null
}
const authSlice=createSlice({
    name:'auth',
    initialState,
    reducers:{
        logout:(state)=>{
            state.user=null;
            state.isAuthenticated=false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                
                // Extract only the necessary data from the payload
                const responseData = action.payload?.data;
                // console.log('sattee',state);
                // console.log('action',action);
                if(action.payload?.status===401){
                    state.error='Unauthorized';
                    return;
                }
                
                if (action.payload?.status === 200) {
                    // Set token and user in localStorage
                    localStorage.setItem('token', responseData.data.token);
                    localStorage.setItem('user', JSON.stringify(responseData.data.user));
                    
                    // Update state
                    state.token = responseData.data.token;
                    state.user = responseData.data.user;
                    state.isAuthenticated = true;
                } else {
                    // console.log('responseData',responseData);
                    state.error = responseData?.message || 'Something went wrong.';
                }
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                
                // Handle errors
                if (typeof action.payload === 'string') {
                    state.error = action.payload;
                } else if (Array.isArray(action.payload) && action.payload.length > 0) {
                    state.error = action.payload[0].message;
                } else {
                    state.error = 'Login failed due to an unknown error.';
                }
            })
        .addCase(register.pending,(state)=>{
            state.loading=true;
            state.error=null;
        })
        .addCase(register.fulfilled,(state,{payload})=>{
            state.loading=false;
            if(payload?.code==='SUCCESS'){
            localStorage.setItem('token',payload?.data?.token);
            state.token=payload?.data?.token;
            state.user=payload?.data?.user;
            state.isAuthenticated=true;
            }
            else{
                state.error=payload?.message;
            }

        })
        .addCase(register.rejected,(state,{payload})=>{
            state.loading=false;
            // console.log('payload',payload);
            if(typeof payload === 'string'){
                state.error=payload;
            }
            else{
                state.error=payload[0].message;
            }
        })
        .addCase(forgot.pending,(state)=>{
            state.loading=true;
            state.error=null;
        })
        .addCase(forgot.fulfilled,(state,{payload})=>{
            state.loading=false;
            state.user=payload.user;
            state.isAuthenticated=true;
        })
        .addCase(forgot.rejected,(state,{payload})=>{
            state.loading=false;
            if (typeof payload === 'string') {
                state.error = payload;
            }
            else {
                state.error = payload[0].message;
            }
        })
        .addCase(logout.pending,(state)=>{
            state.loading=true;
            state.error=null;
        })
        .addCase(logout.fulfilled,(state)=>{
            state.loading=false;
            state.user=null;
            state.isAuthenticated=false;
            state.token=null;
            
        })
        .addCase(logout.rejected,(state,{payload})=>{
            state.loading=false;
            state.error=payload;
        })
        .addCase(updateUser.pending,(state)=>{
            state.loading=true;
            state.error=null;
        })
        .addCase(updateUser.fulfilled,(state,{payload})=>{
            state.loading=false;
            if(payload?.code==='SUCCESS'){
            state.user=payload?.data?.user;
        //   console.log('result payload', payload?.data?.user);
          localStorage.setItem('user', JSON.stringify(payload?.data?.user));
            }
            else{
                state.error=payload?.message;
            }
        })
        .addCase(updateUser.rejected,(state,{payload})=>{
            state.loading=false;
            // console.log('payload in reject',payload);
            if(typeof payload === 'string'){
                state.error=payload;
            }
            else{
                state.error=payload[0]?.message;
            }
        })
        .addCase(updatePassword.pending,(state)=>{
            state.loading=true;
            state.error=null;
        })
        .addCase(updatePassword.fulfilled,(state,{payload})=>{
            state.loading=false;
                state.error=payload?.message;
            
        })
        .addCase(updatePassword.rejected,(state,{payload})=>{
            state.loading=false;
            if(typeof payload === 'string'){
                state.error=payload;
            }
            else{
                state.error=payload[0]?.message;
            }
        })
    }
});
export default authSlice.reducer;

